"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    // Change nc_order from integer to float
    await knex.schema.alterTable(_globals.MetaTable.ROW_COLOR_CONDITIONS, (table)=>{
        table.float('nc_order').alter();
    });
};
const down = async (knex)=>{
    // Revert nc_order back to integer
    await knex.schema.alterTable(_globals.MetaTable.ROW_COLOR_CONDITIONS, (table)=>{
        table.integer('nc_order').alter();
    });
};
